import React from 'react'
import ReactDOM from 'react-dom'
import '../../graphic/style.sass'


export class Button extends React.Component{
	render(){
		return(
			<div className={this.props.className} onClick={this.props.handler}>{this.props.name}</div>
		)
	}

}



// WEBPACK FOOTER //
// ./src/components/core/button.js